module.exports = __webpack_public_path__ + "img/footer.b570315b.png";